<template>
  <div>
    <el-tabs :value="tabName" type="border-card">
      <el-tab-pane name="MasterBudget" label="Presupuesto Maestro">
        <el-card>
          <div style="float: right">
            <yearcomponent @change="handler_year" />

            <el-select
              v-model="valueCompanys"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in companys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <el-select
              v-model="DimensionProducto"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in DimensionProductoOptions"
                :key="item.Code"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
            </el-select>

            <el-select
              v-model="DimensionDepartamento"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in DimensionDepartamentoOptions"
                :key="item.Code"
                :label="item.Name"
                :value="item.Code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="valueMoney"
              v-bind="$attrs"
              size="mini"
              placeholder="Select"
              v-loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div style="margin-top: 50px">
            <rabbey-table3
              :columns="months"
              :data="dataReStatus"
              :actions="actions"
              :loading="loading"
              :row-class-name="changeRowClassName"
              :maxheight="1000"
              :paginationApi="{
                currentPage: 1,
                pageSize: 200
              }"
              :pageSizes="[200, 400, 600]"
              @rtable-push-action="handleAction"
              default-expand-all
            ></rabbey-table3>
          </div>
        </el-card>
      </el-tab-pane>
      <el-tab-pane name="BudgetExecution" label="Ejecucion de presupuesto">
        <budgetExecution />
      </el-tab-pane>
      <el-tab-pane name="ExecutionBudget" label="Presupuesto Ejecucion">
        <Budgets2 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import { Months } from "@/helpers/MonthsColumns";
import {
  Months,
  Actions
} from "@/views/modules/Status/columns/MonthColumnsBudgetMaster";
import yearcomponent from "@/components/Global_System/YearsComponent";
import budgetExecution from "@/views/modules/Status/budgetExecution/budgetExecution.vue";
import Budgets2 from "@/views/modules/Status/budget/Budgets2.vue";

export default {
  name: "Budgets",
  components: {
    yearcomponent,
    budgetExecution,
    Budgets2
  },
  data() {
    return {
      tabName: "MasterBudget",
      months: Months(this),
      loading: false,
      options: [
        {
          value: "RD",
          label: "RD$"
        },
        {
          value: "US",
          label: "US$"
        }
      ],
      companys: [
        {
          value: 4,
          label: "Magycorp Technologies"
        },
        {
          value: 5,
          label: "Magycorp SA"
        },
        {
          value: 2,
          label: "MAGYTRACK"
        },
        {
          value: 1,
          label: "TENNOS BUSINESS"
        },
        {
          value: 9,
          label: "VENTAFIEL TECHNOLOGIES"
        },
        {
          value: 6,
          label: "RABBEY"
        },
        {
          value: 7,
          label: "NUPSHOP"
        },
        {
          value: "Consolidado",
          label: "Consolidado"
        }
      ],
      dataReStatus: [],
      actions: Actions,
      editEneable: false,
      year: 2023,
      valueCompanys: 4,
      valueMoney: "RD",
      DimensionProductoOptions: [],
      DimensionProducto: "*",
      DimensionDepartamentoOptions: [],
      DimensionDepartamento: "*"
    };
  },
  mounted() {
    this.getDimension();
    this.GetBudget();
  },
  methods: {
    handler_year(_year) {
      this.year = _year;
      this.GetBudget();
    },
    getDimension() {
      this.loading = true;

      this.$http
        .get(`/api/resultsStatus/GetDimesionProducto`)
        .then((resp) => {
          this.loading = false;
          this.DimensionProductoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));

      this.$http
        .get("/api/resultsStatus/GetDimesionDepartamento")
        .then((resp) => {
          this.loading = false;
          this.DimensionDepartamentoOptions = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    GetBudget() {
      this.loading = true;

      var params = {
        option: this.valueCompanys,
        year: this.year,
        divisa: this.valueMoney,
        dim_pro: this.DimensionProducto,
        dim_dep: this.DimensionDepartamento
      };
      this.$http
        .get(`/api/resultsStatus/GetBudget`, {
          params: params
        })
        .then((resp) => {
          this.loading = false;

          this.dataReStatus = resp.data;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => (this.loading = false));
    },
    async updatingAccountValue(newValue, data) {
      const params = {
        newAmount: newValue,
        accountNo: data.attrs.row.cuenta,
        month: data.attrs.mes,
        year: this.year,
        option: this.valueCompanys
      };

      if (data.attrs.rowValue !== null) {
        await this.$http
          .put("/api/resultsStatus/UpdateBudgetAccValue", params)
          .then((resp) => {
            resp;

            if (resp.data > 0) {
              this.$message({
                showClose: true,
                message: " Campo actualizado exitosamente !",
                type: "success"
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      } else {
        await this.$http
          .post("/api/resultsStatus/InsertNewBudgetMovement", params)
          .then((resp) => {
            if (resp.data > 0) {
              this.$message({
                showClose: true,
                message: " Campo actualizado exitosamente !",
                type: "success"
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    handleAction(action) {
      action;

      this.editEneable = true;
    },
    changeRowClassName({ row /*, rowIndex*/ }) {
      switch (row.cuenta) {
        case "79999995": {
          return "fixedRow2";
        }
        case "79999997": {
          return "fixedRow1";
        }
        case "79999999": {
          return "fixedRow";
        }
        default: {
          break;
        }
      }
    }
  },
  watch: {
    DimensionProducto() {
      this.GetBudget();
    },
    DimensionDepartamento() {
      this.GetBudget();
    },
    valueCompanys() {
      this.GetBudget();
    },
    year() {
      this.GetBudget();
    },
    valueMoney() {
      this.GetBudget();
    }
  }
};
</script>

<style scoped lang="scss">
/*
.fixedRow {
    position: sticky;
    bottom: 0;
}
.fixedRow1 {
  position: sticky;
  bottom: 10;
}
.fixedRow2 {
  position: sticky;
  bottom: 20;
}
*/
/*
.el-table .fixedRow{
  position: fixed;
  bottom: 0;
  background: greenyellow;
  background-color: greenyellow;
  color: blueviolet;

}

.fixedRow{
  position: fixed;
  bottom: 0;
  background: greenyellow;
  background-color: greenyellow;
  color: blueviolet;

}
*/
</style>
